import { useEffect, useState } from "react";
import { Plus, Save } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export const CatalogSettings = ({ session, onBack }) => {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({ name: "", kind: "module" });
  const [priceDraft, setPriceDraft] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  useEffect(() => { api.get("/catalog").then(({ data }) => { setItems(data.items);
    setPriceDraft(Object.fromEntries(data.items.map((item) => [item.id,
      item.price_cents == null ? "" : (item.price_cents / 100).toFixed(2)]))); })
    .catch((e) => setError(errorMessage(e))); }, []);
  const change = (id, field, value) => { setSaved(false);
    setItems((current) => current.map((item) => item.id === id ? { ...item, [field]: value } : item)); };
  const add = () => {
    const name = draft.name.trim();
    const id = name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60);
    if (!name || id.length < 2 || items.some((item) => item.id === id)) { setError("Scegli un nome diverso."); return; }
    setItems((current) => [...current, { id, name, kind: draft.kind, description: "", price_cents: null, active: true }]);
    setDraft({ name: "", kind: "module" }); setError(""); setSaved(false);
  };
  const save = async () => {
    setBusy(true); setError(""); setSaved(false);
    try {
      const values = items.map((item) => ({ ...item, price_cents: priceDraft[item.id] === "" ||
        priceDraft[item.id] === undefined ? null : Math.round(Number(priceDraft[item.id]) * 100) }));
      await api.put("/catalog", { items: values }, { headers: { "X-CSRF-Token": session.csrf_token } });
      setItems(values);
      setSaved(true);
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <div className="catalog-settings" data-testid="catalog-settings">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="catalog-back">‹ Impostazioni</button>
    <h2 className="sheet-title">CATALOGO</h2>
    {items.map((item) => <div className="catalog-edit-item" key={item.id} data-testid={`catalog-item-${item.id}`}>
      <div className="form-field"><label htmlFor={`catalog-name-${item.id}`}>NOME · {item.kind === "module" ? "MODULO" : "BUNDLE"}</label>
        <input id={`catalog-name-${item.id}`} value={item.name} onChange={(e) => change(item.id, "name", e.target.value)}
          data-testid={`catalog-name-${item.id}`} /></div>
      <div className="form-field"><label htmlFor={`catalog-price-${item.id}`}>PREZZO MENSILE {item.kind === "bundle" ? "PER UNITÀ" : ""} · €</label>
        <input id={`catalog-price-${item.id}`} type="number" min="0" step="0.01"
          value={priceDraft[item.id] ?? ""}
          onChange={(e) => { setPriceDraft((current) => ({ ...current, [item.id]: e.target.value })); setSaved(false); }}
          placeholder="Da configurare" data-testid={`catalog-price-${item.id}`} /></div>
      <div className="form-field"><label htmlFor={`catalog-description-${item.id}`}>DESCRIZIONE BREVE</label>
        <input id={`catalog-description-${item.id}`} maxLength={300} value={item.description || ""}
          onChange={(e) => change(item.id, "description", e.target.value)}
          data-testid={`catalog-description-${item.id}`} /></div>
      <label className="catalog-active"><input type="checkbox" checked={item.active}
        onChange={(e) => change(item.id, "active", e.target.checked)}
        data-testid={`catalog-active-${item.id}`} /> Disponibile</label>
    </div>)}
    <div className="catalog-add"><input aria-label="Nome nuovo prodotto" placeholder="Nuovo prodotto" value={draft.name}
      onChange={(e) => setDraft({ ...draft, name: e.target.value })} data-testid="catalog-new-name" />
      <select aria-label="Tipo prodotto" value={draft.kind} onChange={(e) => setDraft({ ...draft, kind: e.target.value })}
        data-testid="catalog-new-kind"><option value="module">Modulo</option><option value="bundle">Bundle × quantità</option></select>
      <button type="button" className="hud-button hud-secondary" onClick={add} data-testid="catalog-add-button"><Plus size={17} /> Aggiungi</button></div>
    {error && <p role="alert" className="form-error" data-testid="catalog-error">{error}</p>}
    {saved && <p role="status" className="venue-success" data-testid="catalog-saved">Catalogo aggiornato.</p>}
    <button type="button" className="hud-button" disabled={busy || !items.length} onClick={save}
      data-testid="catalog-save-button"><Save size={17} /> {busy ? "Salvataggio…" : "Salva catalogo"}</button>
  </div>;
};